export { print as printAST } from 'graphql/language/printer';
export { ObservableQuery, } from './core/ObservableQuery';
export { NetworkStatus } from './core/networkStatus';
export * from './core/types';
export { ApolloError } from './errors/ApolloError';
import ApolloClient from './ApolloClient';
// export the client as both default and named
export { ApolloClient };
export default ApolloClient;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /home/alarmplan/staging/shared/frontend/~/apollo-client/index.js
// module id = 304
// module chunks = 0